var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog308(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_308"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_308",
    "data-name": 308,
    className: "cls-2",
    d: "M58.68,2.31C44.43-.38,35.15,16.39,30.53,28.78c-6.25,16.82-12.35,65.62,13.39,69,25.5,3.34,34.8-47.94,30.48-67.52C73.2,24.8,68.66,4.2,58.68,2.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog308);
export default __webpack_public_path__ + "static/media/dog_308.eacffbc4276b2a709eb71c2a9067abd6.svg";
export { ForwardRef as ReactComponent };